import React from 'react'
import {Field, InjectedFormProps, reduxForm} from 'redux-form'
import {
  FormButtons,
  renderers,
} from '../../components'




export type PONumberFormProp={

}
const FORM_NAME = "DEVICE_FORM"
const PONumberFormHTML : React.FC<PONumberFormProp & InjectedFormProps<{},PONumberFormProp>> =  ({
  handleSubmit,
  pristine,
  reset,
  submitting,
}) => {
  return (
    <form onSubmit={handleSubmit}>


          <Field
        name="purchaseOrderNumber"
        label="Purchase Order Number"
        component={renderers.renderField}
        type="text"
      />



      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}

// Decorate with redux-form
let PONumberForm = reduxForm({
  form: FORM_NAME,
})(PONumberFormHTML)

export default PONumberForm
